var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-avances-expediente-contrato"}},[_c('desktop',{attrs:{"listadoDocumentosPresentacion":_vm.listadoDocumentosPresentacion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }